<app-page-breadcrumb [isModal]="isModal" [pageInfo]="{title:'Sponsor Info'}" />
<div class="row text-center">
    <div class="col-lg-4 col-md-12 col-xl-4" *ngIf="!loadingData">
        <profile-widget [profileData]="sponsorData" />
    </div>
    <div class="col-lg-8 col-md-8 col-xl-8" *ngIf="!loadingData ">
        <div class="row pt-5 about-list">
            <info-view [sourceData]="sponsorData" [mapData]="showData" />
        </div>
    </div>
    <app-page-loader [loading]="loadingData" />
    <div class="row clearfix align-center mb-2" *ngIf="sponsorData?.id">
        <m-groupButton [bkBtnShow]="true" [btnGroup]="buttonGroup" [onclickPromise]="onClickBtn" />
    </div>
</div>